import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
    Visibility,
    Edit,
    Cancel,
    FilterList,
    Search,
} from "@mui/icons-material";
import {
    Table,
    Button,
    Form,
    InputGroup,
    Row,
    Col,
    Badge,
} from "react-bootstrap";
import DataTable from "../../../Table/DataTable";
import SearchFilterBar from "../../../Table/SearchFilterBar";
import PaginationControl from "../../../Table/PaginationControl";
import { getOrders } from "../../../../actions/orderActions";
import { useDispatch, useSelector } from "react-redux";
import "./Order.css";

const Order = () => {
    const { orders = [], loading = true, error } = useSelector(state => state.orderState);
    const dispatch = useDispatch();
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("All");
    const [page, setPage] = useState(1);
    const perPage = 5;

    useEffect(() => {
        dispatch(getOrders())
    }, [dispatch]);


    const totalPages = Math.ceil(orders?.length / perPage);
    const paginated = orders?.slice((page - 1) * perPage, page * perPage);

    const columns = ["No", "Customer", "Date", "Product", "Total Amount"];

    const renderRow = (order, i) => (
        <tr key={order.id}>
            <td>{i + 1}</td>
            <td>{order.customer.fullName}</td>
            <td>{new Date(order.createdAt).toLocaleDateString("en-AE", {
                year: "numeric",
                month: "short",
                day: "numeric",
            })}</td>
            <td><div className="table-responsive">
                <table className="table align-middle">
                    <thead className="table-dark">
                        <tr>
                            <th className="text-center">#</th>
                            <th className="text-start">Product Name</th>
                            <th className="text-start">Brand</th>
                            <th className="text-center">Color</th>
                            <th className="text-center">Size</th>
                            <th className="text-end">Price (AED)</th>
                            <th className="text-center">Qty</th>
                            <th className="text-end">Subtotal (AED)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {order.products.map((p, index) => (
                            <tr key={p._id}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-start">{p.name}</td>
                                <td className="text-start">{p.brand}</td>
                                <td className="text-center">{p.color}</td>
                                <td className="text-center">{p.size}</td>
                                <td className="text-end">{p.price.toFixed(2)}</td>
                                <td className="text-center">{p.quantity}</td>
                                <td className="text-end">{p.subtotal.toFixed(2)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            </td>
            <td>{order.totalPrice}</td>
        </tr>
    );

    return (
        <div className="container-fluid p-3">
            <h4 className="fw-bold mb-4">Orders Management</h4>

            <SearchFilterBar
                searchTerm={search}
                setSearchTerm={setSearch}
                filterValue={statusFilter}
                setFilterValue={setStatusFilter}
                placeholder="Search product..."
            />

            <DataTable columns={columns} data={paginated} renderRow={renderRow} />
            <PaginationControl totalPages={totalPages} currentPage={page} onPageChange={setPage} />
        </div>
    );
};

export default Order;
